import React from 'react';
import './ListS.scss';

const ListS = (props) => {
  return <div className='ListS'>{props.children}</div>;
};

export default ListS;
